<div class="manage-subscription-container">
  <div class="row">
    <div class="columns small-12 medium-6">

      <!-- Error State -->
      <div *ngIf="loadError" class="error-container">
        <div class="callout alert">
          <p>{{ loadError }}</p>
          <button class="button small" (click)="loadSubscriptionDetails()">Try Again</button>
        </div>
      </div>

      <!-- Subscription Details -->
      <div *ngIf="!loadError && subscriptionData" class="subscription-content">

        <!-- Success Message After Submission -->
        <div *ngIf="submissionComplete" class="success-message callout success">
          <h4>Subscription Updated</h4>
          <p>Your subscription will not renew. You will continue to have access until {{ formatDate(subscriptionData.termEndDate) }}.</p>
          <button class="button" (click)="goToDashboard()">Back to Dashboard</button>
        </div>

        <!-- Subscription Info Card -->
        <div class="subscription-card" *ngIf="!submissionComplete">
          <h3 class="card-title">Subscription Details</h3>

          <div class="subscription-details">
            <div class="detail-row">
              <span class="detail-label">Product:</span>
              <span class="detail-value">{{ subscriptionData.productName }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Status:</span>
              <span class="detail-value status-badge"
                    [ngClass]="{
                      'status-active': isActive(),
                      'status-nonrenewal': isNonRenewal(),
                      'status-inactive': !isActive() && !isNonRenewal()
                    }">
                {{ getStatusDisplay(subscriptionData.displayStatus) }}
              </span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Billing Frequency:</span>
              <span class="detail-value">{{ getBillingFrequencyDisplay(subscriptionData.billingFrequency) }}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Term Start:</span>
              <span class="detail-value">{{ formatDate(subscriptionData.termStartDate) }}</span>
            </div>

            <div class="detail-row" *ngIf="subscriptionData.termEndDate">
              <span class="detail-label">Term End:</span>
              <span class="detail-value">{{ formatDate(subscriptionData.termEndDate) }}</span>
            </div>

            <div class="detail-row" *ngIf="subscriptionData.nextBillingDate">
              <span class="detail-label">Next Billing:</span>
              <span class="detail-value">{{ formatDate(subscriptionData.nextBillingDate) }}</span>
            </div>
          </div>

          <!-- Non-Renewal Message -->
          <div *ngIf="isNonRenewal()" class="inactive-message callout secondary">
            <p>Your subscription is set to not renew<span *ngIf="subscriptionData.termEndDate">. It will end on {{ formatDate(subscriptionData.termEndDate) }}</span>.</p>
            <p>Please contact <a href="mailto:support@taxplaniq.com">support&#64;taxplaniq.com</a> if you require further assistance.</p>
          </div>

          <!-- Non-Active Subscription Message (not non-renewal) -->
          <div *ngIf="!isActive() && !isNonRenewal() && !subscriptionData.canCancelRenewal" class="inactive-message callout secondary">
            <p>Your subscription is currently {{ getStatusDisplay(subscriptionData.displayStatus) }}<span *ngIf="subscriptionData.termEndDate">. It will end on {{ formatDate(subscriptionData.termEndDate) }}</span>.</p>
          </div>

          <!-- Do Not Renew Button (only for ACTIVE subscriptions) -->
          <div *ngIf="subscriptionData.canCancelRenewal && !showDoNotRenewSurvey" class="action-section">
            <button class="button do-not-renew-btn" (click)="showDoNotRenewForm()">
              Do Not Renew
            </button>
          </div>

          <!-- Do Not Renew Survey Form -->
          <div *ngIf="showDoNotRenewSurvey" class="survey-section">
            <hr class="section-divider">

            <h4 class="survey-title">We're sorry to see you go</h4>
            <p class="survey-subtitle">Your feedback helps us improve. Both questions are optional.</p>

            <div class="form-group">
              <label for="primaryReason">Select which best describes why you are not renewing?</label>
              <select id="primaryReason" [(ngModel)]="primaryReason" class="form-control">
                <option value="">-- Select a reason (optional) --</option>
                <option *ngFor="let option of primaryReasonOptions" [value]="option">
                  {{ option }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="additionalFeedback">Anything else you can add to help us improve?</label>
              <textarea
                id="additionalFeedback"
                [(ngModel)]="additionalFeedback"
                class="form-control"
                rows="4"
                placeholder="Share your thoughts (optional)..."
              ></textarea>
            </div>

            <div class="survey-actions">
              <button
                class="button confirm-btn"
                [disabled]="isSubmitting"
                (click)="submitDoNotRenew()">
                <span *ngIf="!isSubmitting">Confirm</span>
                <span *ngIf="isSubmitting">Processing...</span>
              </button>
              <button
                class="button secondary cancel-btn"
                [disabled]="isSubmitting"
                (click)="cancelDoNotRenew()">
                Cancel
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
